<template>
<div class="main_container">
  <section class="model_section">
    <p class="model_top_title">新增/编辑优惠券</p>
    <el-button type="danger" @click="goback()" style="float: right;margin: 5px 10px 0 0;">关闭</el-button>
  </section>
  <!-- 优惠券详情 -->
  <div style="display: flex;justify-content: space-between;width: 99%;">
    <h3 style="margin-left: 20px">优惠券信息</h3>
    <div style="color: #F56C6C;margin-top: 20px;" v-show="yhqType=='4'">重要提示：优惠券售价是在用户付费领券后，将售卖款直接奖励给创客。</div>
  </div>
  <el-form label-width="130px">
    <!-- <el-col :span="11">
      <el-form-item label="选择店铺:" style="position:relative">
        <el-button type="warning" class="ppsClass" @click="handleAddPublisher"> 选择店铺 </el-button>
        <b class="releaseName">{{publisherTitle}}</b>
      </el-form-item>
    </el-col> -->
    <el-form-item label="品类品牌:" style="position:relative" v-show="bbNewType == 1">
      <el-cascader v-model="categoryAndbrand" :options="optionsCategoryBrand"
      placeholder="请选择品类品牌" filterable clearable @change="handleChange"/>
    </el-form-item>

    <el-row>
      <el-col :span="10">
      <el-form-item label="优惠券名称:">
        <el-input v-model="couponname" placeholder="请输入优惠券名称（10字以内）" maxlength="10" style="width: 60%;"/>
      </el-form-item>
      </el-col>
      <el-col :span="10" v-if="yhqType == '1'||yhqType == '4'">
      <el-form-item label="售价:">
        <el-input v-model="Price" placeholder="请输入优惠券的售价" maxlength="10" style="width: 50%;"
        :disabled="seeDis || IsFree == true" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>&nbsp;&nbsp;元
        <el-checkbox @change="mianfei()" v-model="IsFree" v-show="yhqType!='4'" style="margin-left: 20px;">免费</el-checkbox>
      </el-form-item>
      </el-col>
    </el-row>
    
    <el-row>
      <el-col :span="10">
      <el-form-item label="优惠券面值:" prop="FaceValue" style="position:relative">
        <el-input v-model="FaceValue" placeholder="请输入优惠券面值" maxlength="7"
        oninput="value=value.replace(/[^\d]/g,'')" @blur="FaceValue = $event.target.value"
        onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" style="width: 60%;"/>
        <span style="margin-left: 10px;">元</span>
      </el-form-item>
      </el-col>
      <el-col :span="10">
      <el-form-item label="库存:" prop="Stock">
        <el-input v-model="Stock" placeholder="请输入库存" maxlength="7"
        onkeyup="value=value.replace(/[^\d]/g,'');" style="width: 50%;"/>
      </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="10">
      <el-form-item label="使用门槛:" prop="UseThreshold">
        <el-radio v-model="singleChoiceWhether" label="0"> 无门槛 </el-radio>
        <el-radio v-model="singleChoiceWhether" label="1">
          满&nbsp;&nbsp;
          <el-input v-model="UseThreshold" placeholder="请输入金额" :disabled="disableThreshold"
          maxlength="7" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" style="width: 50%;"/>
          &nbsp;&nbsp;元&nbsp;&nbsp;可使用
          </el-radio>
      </el-form-item>
      </el-col>
      <el-col :span="10">
      <el-form-item label="每人可领取:" prop="ReceiveNumber">
        <el-input v-model="ReceiveNumber" :disabled="receiveDisable" maxlength="7"
        placeholder="请输入" onkeyup="value=value.replace(/[^\d]/g,'');" style="width: 50%;"/>
        &nbsp;&nbsp;张&nbsp;&nbsp;
        <!-- <el-checkbox @change="endUnlimited()" v-model="noLimit">无限制</el-checkbox> -->
      </el-form-item>
      </el-col>
    </el-row>
    <h3 style="margin-left: 20px">优惠券使用规则</h3>
    <el-row>
      <el-col :span="10">
        <el-form-item label="有效时间：">
          <el-date-picker type="daterange" v-model="effectiveTime" @change="changeActiveTime"
          value-format="yyyy-MM-dd" style="width: 60%;"
          start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptionsStart"/>
        </el-form-item>
      </el-col>
      <!-- <el-col :span="13" v-if="bbNewType == 1">
        <el-form-item label="是否适用于特价商品/套餐:" prop="IsUseSpecialOffer" label-width="210px">
            <el-checkbox v-model="IsUseSpecialOffer"/>
        </el-form-item>
      </el-col> -->
    </el-row>
    <!-- 富文本 -->
    <el-form-item label="特殊说明：" style="width: 80%">
      <wjEditor :desc="SpecialInstructions" @change="contentChangeOne" style="width:90%;margin-bottom: 30px;"/>
    </el-form-item>

    <!-- :::::::::: 优惠券-操作按钮 :::::::::: -->
    <div class="gudingdibu">
      <el-button @click="goback()">取消</el-button>
      <el-button type="primary" class="search_btn" @click="saveCouponForm()">保存</el-button>
    </div>
  </el-form>

  <!-- 选择店铺 -->
  <el-dialog title="选择店铺" :visible.sync="dialogVisibledis" width="40%" center>
    <el-form style="display:flex;">
      <el-form-item label="店铺名称：" style="display:flex;width:50%;margin-right:10px;">
        <el-input v-model="publisherPhone" placeholder="请输入店铺名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="danger" @click="finddes()">查 询</el-button>
      </el-form-item>
    </el-form>
    <div class="disoutline">
      <ul @click="handleGetdesId(item)" v-for="(item,index) in desarr" :key="index" class="disinline">
        <li><b>{{item.name}}</b></li>
        <li>{{item.provinceName}} - {{item.cityName}}</li>
        <li>{{item.phone}}</li>
        <el-radio v-model="choiceRadioId" :label="item.id" class="elRadio">选择</el-radio>
      </ul>
      <p style="text-align:center" v-show="nofind">查无结果</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisibledis = false">取 消</el-button>
      <el-button type="danger" @click="makedes()">确 定</el-button>
    </div>
  </el-dialog>
  
</div>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import wjEditor from '../../components/MyWangEditor';
import { postCouponsAdd, postCouponsEdit, getUpdateCoupoon, getUserIsAdminOrTZRStaff,
  getActivityExibitionBrandsForBrandBusiness, getEffectiveBrandBusiness } from "../../api/activityFormList";
export default {
  mixins: [alertTrends],
  components: { wjEditor },
  data() {
    return {
      id: "", // 优惠券id
      seeDis: false, // 置灰
      noLimit: false, // 领取次数无限制
      
      BrandTypeId: 0, // 品类
      BrandId: 0, // 品牌
      couponname: "", // 优惠券名称
      IsFree: false, // 售价默认不选中
      Price: "", // 优惠券售价
      FaceValue: "", // 优惠券面值
      Stock: "", // 库存

      singleChoiceWhether: "0", //是否有使用门槛
      UseThreshold: "", //有门槛时 满减的金额
      disableThreshold: true, // 禁用输入框状态

      ReceiveNumber: "", // 领取次数



        receiveDisable: false,

        StartTime: "", // 开始时间
        EndTime: "", // 结束时间
        IsUseSpecialOffer: false, // 是否使用特价商品/套餐
        
        SpecialInstructions: `<p>1、此优惠券适用于线上购买抵扣，也适用于线下的店铺消费抵扣。</p>
        <p>2、秒杀、拼团类产品不参加</p>
        <p>3、商家店铺或体验店购买商品并支付时请和导购提前沟通并确认购买商品是否可以使用此优惠券！</p>
        <p>4、其他</p>`,
      effectiveTime: "", // 有效时间
      // 控制活动时间不能小于当前时间
      pickerOptionsStart: {
        disabledDate(time) {
          return (
            time.getTime() < new Date(new Date().toLocaleDateString()).getTime()
          );
        },
      },
      categoryAndbrand: "", // 品类品牌
      optionsCategoryBrand: [],
      userStaff: "", // 是否是超级管理员或甄惠装员工
      publisherTitle: "", // 店铺名称回显
      dialogVisibledis: false, // 选择店铺弹框
      publisherPhone: "", // 店铺名称
      desarr: [], // 店铺列表
      choiceRadioId: 0, // 店铺id
      choiceRadioName: "", // 店铺姓名
      nofind:false, // 查无结果
      bbNewType: '', // 1=品牌建材  2=装修公司
      yhqType: '', // 优惠券类型
      yhqBbid: '', // 店铺id
    };
  },
  watch: {
    // 监听使用门槛
    'singleChoiceWhether'(nv,ov) {
      if(this.singleChoiceWhether == '1') {
        this.disableThreshold = false;
      } else {
        this.disableThreshold = true;
        this.UseThreshold = "";
      }
    }
  },
  methods: {
    contentChangeOne(content) {
      this.SpecialInstructions = content;
    },
    // 初始化页面
    init() {
      this.id = this.$route.query.id || "";
      this.yhqBbid = this.$route.query.bbid;
      this.bbNewType = this.$route.query.bbType; // 1=品牌建材  2=装修公司
      this.yhqType = this.$route.query.type; // 优惠券类型
      this.getCategoryBrand(this.yhqBbid); // 品类品牌
      // 优惠券回显接口
      if(this.id) {
        getUpdateCoupoon('',this.id).then(data => {
          let thisObj = data.resultObj;
          this.couponname = thisObj.couponname; // 优惠券名称
          // 判断回显售价
          if(thisObj.price == 0) {
            this.IsFree=true;
            this.Price = ""; // 清空输入框内容并
            this.seeDis = true; // 置灰输入框
          }else{
            this.IsFree=false;
            this.Price = thisObj.price; // 售价（为0时表示免费） 单位：元
            this.seeDis = false; // 解开置灰输入框
          }
          this.FaceValue = thisObj.facevalue; // 优惠券面值 单位：元
          this.Stock = thisObj.stock; // 库存
          // 判断使用门槛
          if(thisObj.usethreshold == 0) {
            this.singleChoiceWhether = '0';
            this.UseThreshold = "";
            this.disableThreshold = true;
          } else {
            this.singleChoiceWhether = '1';
            this.UseThreshold = thisObj.usethreshold; // 使用门槛（为0时表示无门槛） 单位：元
            this.disableThreshold = false;
          }
          this.ReceiveNumber = thisObj.receivenumber; // 可领取数量
          this.StartTime = thisObj.starttime;
          this.EndTime = thisObj.endtime;
          this.effectiveTime = [this.StartTime,this.EndTime];
          this.SpecialInstructions = thisObj.specialinstructions; // 特殊说明
          
          // 判断领取数量
          // if(thisObj.IsUnlimited == true) {
          //   this.noLimit = true; // 复选框 false 默认不选中  true 为选中
          //   thisObj.ReceiveNumber = ""; // 清空输入框内容并
          //   thisObj.receiveDisable = true; // 置灰输入框
          // }
          
          // this.choiceRadioId = thisObj.shopid;
          // this.publisherTitle = thisObj.BbName;
          this.yhqBbid = thisObj.shopid; // 所属店铺ID
          this.bbNewType = thisObj.shoptype;
          if(this.bbNewType == 1) {
            // this.getCategoryBrand(this.choiceRadioId); // 品类品牌
            this.getCategoryBrand(this.yhqBbid); // 品类品牌
            this.categoryAndbrand = [thisObj.brandtypeid,thisObj.brandid]; // 回显品类品牌
            this.BrandTypeId = thisObj.brandtypeid; // 品类
            this.BrandId = thisObj.brandid; // 品牌
          }
        });
      } else { // 新增进来的
        
      }
    },
    // 保存 提交优惠券内容
    saveCouponForm(){
      // if(this.userStaff && this.publisherTitle == '') {
      //   this.showAlert('请选择店铺');
      //   return false;
      // }
      if(this.bbNewType == 1 && this.categoryAndbrand == ""){
        this.showAlert('请选择品类品牌');
        return false;
      }
      if (!this.couponname) {
        this.showAlert('请输入优惠券名称');
        return false;
      }
      // 判断售价 如果没有选中免费
      if (this.IsFree == false) {
        if(this.yhqType == '1'){
          if (!this.Price) {
            this.showAlert('请输入优惠券售价');
            return false;
          }
          if (Number(this.Price) < 0.1 || Number(this.Price) > 9999999.99 ) {
            this.showAlert('优惠券售价,范围应在 0.1～9999999.99');
            return false;
          }
        }
        if(this.yhqType == '4'){
          if (!this.Price) {
            this.showAlert('请输入优惠券售价');
            return false;
          }
          if (Number(this.Price) < 1 || Number(this.Price) > 999 ) {
            this.showAlert('优惠券售价,范围应在 1～999');
            return false;
          }
        }
      }
      // 判断优惠券面值
      if (!this.FaceValue) {
        this.showAlert('请输入优惠券面值');
        return false;
      }
      if (this.FaceValue < 0.1 || this.FaceValue > 9999999.99 ) {
        this.showAlert('请输入优惠券面值,范围应在 0.1～9999999.99');
        return false;
      }
      // 判断库存
      if (!this.Stock) {
        this.showAlert('请输入库存');
        return false;
      }
      if (this.Stock < 1 || this.Stock > 100000 ) {
        this.showAlert('请输入库存,范围应在 1～10万');
        return false;
      }
      // 使用门槛
      if(this.singleChoiceWhether == '1') {
        if (!this.UseThreshold) {
          this.showAlert('请输入使用门槛金额');
          return false;
        }
        if (this.UseThreshold < 1 || this.UseThreshold > 9999999 ) {
          this.showAlert('请输入使用门槛金额,范围应在 1～99999999');
          return false;
        }
      }
      // 每人可领取数量
      if (!this.noLimit) {
        if (!this.ReceiveNumber) {
          this.showAlert('请输入每人可领取数量');
          return false;
        }
        if (this.ReceiveNumber < 1 || this.ReceiveNumber > 99999 ) {
          this.showAlert('每人可领取数量,范围应在 1～99999');
          return false;
        }
      }
      // 有效时间
      if (!this.effectiveTime) {
        this.showAlert('请选择有效时间');
        return false;
      }
      // 优惠券特殊说明
      if (!this.SpecialInstructions) {
        this.showAlert('请输入优惠券特殊说明');
        return false;
      }
      setTimeout(()=>{
      // 新增&编辑修改优惠券
      if(this.id){ var yhqid = this.id; }
      let addParams = {
        couponid: yhqid, // 优惠券ID
        couponname: this.couponname, // 优惠券名称
        coupontype: this.yhqType, // 优惠券类型1=普通优惠券、2=快乐装修优惠券、3=活动优惠券 4=店铺推广券
        price: this.IsFree==true ? 0 : Number(this.Price), // 售价 单位：元
        facevalue: this.FaceValue, // 优惠券面值 单位：元
        usethreshold: this.singleChoiceWhether == '0' ? 0 : Number(this.UseThreshold), // 使用门槛（优惠券限制使用金额 单位：元）
        receivenumber: this.noLimit ? 0 : Number(this.ReceiveNumber), // 每人领取数量 0=无限制
        starttime: this.StartTime, // 开始时间
        endtime: this.EndTime, // 结束时间
        stock: Number(this.Stock), // 库存
        shopid: this.yhqBbid, // 店铺id
        specialinstructions: this.SpecialInstructions, // 特殊说明
        brandtypeid: this.BrandTypeId, // 品类id
        brandid: this.BrandId, // 品牌id

        // Bbid: this.choiceRadioId, // 店铺id
        // OperatorId: localStorage.Id, // 操作人
        // IsUnlimited: this.noLimit, // 是否无限制领取
        // IsUseSpecialOffer: this.IsUseSpecialOffer, // 是否适用于特价商品、套餐
      }
      let thisApi = this.id?postCouponsEdit:postCouponsAdd;
      thisApi(addParams).then(data => {
        let that = this;
        if (data.resultCode == 1) {
          this.showAlert('操作成功', 'success');
          // localStorage.setItem("bbid", this.yhqBbid);
          // localStorage.bbid = this.yhqBbid; // 店铺id
          // this.$router.go(-1);
          // this.$router.push({path:'/couponList',query:{bbid:this.yhqBbid}})
          // this.$router.push({path:'/couponList',params: {bbid:this.yhqBbid}})
          this.$router.push({
            name:"couponList",
            params:{
              bbid: that.yhqBbid, // 店铺id
              bbType: that.bbNewType, // 店铺类型
              type: that.yhqType, // 优惠券类型
            }
          })
        }
      });
      },300)
    },
    // 点击选择店铺
    handleAddPublisher() {
      this.publisherPhone = "";
      this.dialogVisibledis = true;
      this.queryBrand();
    },
    // 查询
    finddes() {
      this.queryBrand();
    },
    // 查询店铺
    queryBrand() {
      var obj = {
        userId: localStorage.Id, // 登陆人id（新增）
        key: this.publisherPhone // 店铺名称
      };
      getEffectiveBrandBusiness(obj).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.desarr = data.resultObj;
            this.nofind = false;
          } else {
            this.desarr = [];
            this.nofind = true;
          }
        } else {
          this.desarr = [];
          this.nofind = true;
        }
      });
    },
    // 选中店铺区域
    handleGetdesId(val) {
      this.choiceRadioId = val.id; // 获取店铺id
      this.choiceRadioName = val.name; // 获取店铺姓名
      this.bbNewType = val.bbType; // bbType：1=品牌建材  2=装修公司
    },
    // 确定选择店铺
    makedes() {
      this.dialogVisibledis = false;
      this.publisherTitle = this.choiceRadioName; // 赋值店铺名称
      if(this.bbNewType == 1) {
        this.getCategoryBrand(this.choiceRadioId); // 品类品牌
      }
    },
    // 售价 选中免费 :: 清空输入框
    mianfei() {
      if (this.IsFree == true) {
        this.Price = "";
        this.seeDis = true; // 置灰输入框
      }else{
        this.seeDis = false; // 解开置灰输入框
      }
    },
    // 选中无限制
    endUnlimited() {
      if (this.noLimit == true) {
        this.ReceiveNumber = "";
        this.receiveDisable = true; // 置灰输入框
      }else{
        this.receiveDisable = false; // 解开置灰输入框
      }
    },
    // 活动时间转换
    changeActiveTime() {
      if(this.effectiveTime+""=="null"){
        this.effectiveTime = ["",""]
      }
      this.StartTime = this.effectiveTime[0];
      this.EndTime = this.effectiveTime[1];
    },
    // 请选择品类品牌
    handleChange(val) {
      this.BrandTypeId = val[0]; // 品类
      this.BrandId = val[1]; // 品牌
    },
    // 查找品类品牌
    getCategoryBrand(valId) {
      var loginParams = {
        // bbId: valId ? valId : localStorage.BbId // 商家id
        bbid: valId, // 店铺id
      };
      getActivityExibitionBrandsForBrandBusiness(loginParams).then(data => {
        let that = this;
        let categoryVBrands = [];
        data.ResultObj.map(item => {
          // 品类
          let categoryData = {value:item.id,label:item.name,children:[]};
          categoryVBrands.push(categoryData);
          // 品牌
          item.BDAcivityExhibitionBrands.map(brands => {
            let brandsData = {value:brands.id, label:brands.name};
            categoryData.children.push(brandsData);
          })
        });
        that.optionsCategoryBrand = categoryVBrands;
      })
    },
    // 取消按钮 返回上一级
    goback () {
      // this.$router.go(-1);
      this.$router.push({
        name:"couponList",
        params:{
          bbid: this.yhqBbid, // 店铺id
          bbType: this.bbNewType, // 店铺类型
          type: this.yhqType, // 优惠券类型
        }
      })
    },
    // 判断用户是否是超级管理员或甄惠装员工
    userTZstaff() {
      var obj = {
        userId: localStorage.Id // 用户id
      };
      getUserIsAdminOrTZRStaff(obj).then((data) => {
        if (data.ResultCode == 1) {
          this.userStaff = data.ResultObj; // true为是超级管理员或甄惠装员工，false为不是
        }
      });
    },
  },
  created() {
    this.init(); // 初始化
    // this.userStaff = this.$route.query.userTZstaff;
    this.userTZstaff();
  },
};
</script>
<style scoped>
/* 选择店铺 */
.ppsClass {
  height: 36px;
  line-height: 0;
  display: inline-block;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  margin-top: 5px;
  margin-right: 20px;
}
.disoutline {
  max-height: 260px;
  height: auto;
  overflow: auto;
  border: 1px solid #eee;
  padding: 0 15px 0 15px;
}
.disinline {
  height: 46px;
  line-height: 46px;
  display:flex;
  justify-content: space-between;
  height: auto;
  border-bottom: 1px solid #eee;
  cursor: pointer;
}
.disinline>li {
  width: 60%;
}
.elRadio {
  width: 20%;
  height: 46px;
  line-height: 46px;
}
.releaseName {
  display: block;
  width: 50%;
  height: 30px;
  overflow:hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #888;
  /* text-align: right; */
}
</style>


// WEBPACK FOOTER //
// couponAdd.vue?53251e58